import { AxiosResponse } from 'axios';

import api from 'services/api';

import { IParameterData, IParamApi, IParamsUpdadeData } from '../types';

export const getParameters = (
  params: IParamApi
): Promise<AxiosResponse<IParameterData[]>> => {
  return api.get<IParameterData[]>('Common/ParametroGenerico/Lista', {
    params,
  }) as Promise<AxiosResponse<IParameterData[]>>;
};

export const updateParametersAPI = (
  updateData: IParamsUpdadeData[]
): Promise<AxiosResponse<void>> =>
  api.put('Common/ParametroGenerico', updateData);
